import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Tooltip from 'antd/es/tooltip';

const TrailBar = styled.div`
  background-color: #E4E8ED;
  height: 24px;
  border-radius: ${props => props.shape === 'rounded' ? '16px' : 0};
  width: 100%;

  display: flex;
  justify-content: flex-start;
  cursor: pointer;
  overflow: hidden;
`;

const SegmentBar = styled.div`
  &:hover {
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
  }
`;

const TimelineBar = ({
  segments,
  valueField,
  colorField,
  min,
  max,
  borderShape,
  trailStyle = {},
  ...rest
}) => {
  let totRemoved = 0;
  let totalNonBlack = 0;

  const percentages = segments.map(item => {
    let value = item[valueField];
    const precision = Math.pow(10, 5);
    let res = Math.round(value * precision * 100 / (max - min)) / precision;

    let color = item[colorField];
    if(color === '#232526')
      {
        if(res !== 13)
        {
          totRemoved += (res - 13);
          res = 13;
        }
    } else if (color !== '#232526') {
      totalNonBlack += res;
    }
    return res;
  });

  if (totalNonBlack === 0) {
    for (let i = 0; i < segments.length; i++) {
      if (segments[i][colorField] === '#232526') {
        percentages[i] = 100;
        break;
      }
    }
  } else {
    for (let i = 0; i < segments.length; i++) {
      if (segments[i][colorField] !== '#232526') {
        percentages[i] += totRemoved * percentages[i] / totalNonBlack;
      }
    }
  }

  let total = percentages.reduce((s, v) => s + v, 0);
  if (total > 100) {
    percentages[percentages.length - 1] -= (total - 100);
    total = 100;
  }

  const segmentsEl = (segments || []).map((item, i) => {
    const color = item[colorField];
    let perc = percentages[i];
    if (perc === 0) return null;

    const segmentProps = {
      style: {
        'backgroundColor': color,
        'width': perc + '%',
      }
    };

    let segment = null;

    if (typeof item.render === 'function') {
      segment = item.render();
    }

    if (item.tooltip) {
      segment = <Tooltip key={i} {...item.tooltip}>
        {segment}
      </Tooltip>
    }

    return (
      <SegmentBar key={i} {...segmentProps}>
        {segment}
      </SegmentBar>
    );
  });

  return (
    <TrailBar style={trailStyle} shape={borderShape} {...rest}>
      {segmentsEl}
    </TrailBar>
  );
};

TimelineBar.propTypes = {
  segments: PropTypes.array,
  valueField: PropTypes.string.isRequired,
  colorField: PropTypes.string.isRequired,
  borderShape: PropTypes.oneOf(['rounded', 'square']),
  trailStyle: PropTypes.object,
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
};

TimelineBar.defaultProps = {
  segments: [],
  valueField: 'value',
  colorField: 'color',
  borderShape: 'rounded',
  min: 0,
  max: 100,
};

export default TimelineBar;
